import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import { useFullscreenElement } from '~/client/src/shared/utils/fullscreenElement'
import { HostPortalContainerContext } from '~/client/src/shared/utils/hostPortalContainer'

import { IViewOptionsGroupingProps, IViewOptionsSortingProps } from './types'
import ViewOptionsPopover from './ViewOptionsPopover'
import ViewOptionsSheet from './ViewOptionsSheet'
import ViewOptionsTrigger from './ViewOptionsTrigger'

interface IProps {
  grouping?: IViewOptionsGroupingProps
  sorting?: IViewOptionsSortingProps
}

const ViewOptionsDisplay: React.FC<IProps> = ({ grouping, sorting }) => {
  const { isMobileEnv } = React.useContext(MobXProviderContext) as {
    isMobileEnv?: boolean
  }
  // A body portal renders outside a fullscreen subtree (the map), hence invisible.
  const fullscreenElement = useFullscreenElement() as HTMLElement | null
  const hostPortalContainer = React.useContext(HostPortalContainerContext)
  const [isSheetOpen, setIsSheetOpen] = React.useState(false)

  if (!grouping && !sorting) return null

  return isMobileEnv ? (
    <ViewOptionsSheet
      open={isSheetOpen}
      onOpenChange={setIsSheetOpen}
      trigger={<ViewOptionsTrigger iconOnly size="icon-lg" />}
      grouping={grouping}
      sorting={sorting}
      autoFocusSearch={false}
    />
  ) : (
    <ViewOptionsPopover
      align="end"
      portalContainer={fullscreenElement ?? hostPortalContainer}
      trigger={<ViewOptionsTrigger iconOnly />}
      grouping={grouping}
      sorting={sorting}
    />
  )
}

export default ViewOptionsDisplay
